// @ts-nocheck
import { useIsAuthenticated } from "@store/Framework/Store/Foundation/Context/ContextHooks";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSelectedCategoryPath } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import addProductFilters from "@insite/client-framework/Store/Pages/ProductList/Handlers/AddProductFilters";
import removeProductFilters from "@insite/client-framework/Store/Pages/ProductList/Handlers/RemoveProductFilters";
import { getProductListDataView } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import translate from "@insite/client-framework/Translate";
import { FacetModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { productListCategoryFiltersStyles } from "@insite/content-library/Widgets/ProductList/ProductListCategoryFilters";
import ProductListFiltersAccordionSection from "@insite/content-library/Widgets/ProductList/ProductListFilterAccordionSection";
import { usePriceSortMaximum } from "@store/Extensions/Store/Context/ContextHooks";
import React, { FC, useState } from "react";
import { connect, ResolveThunks } from "react-redux";

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: ApplicationState) => {
    const location = getLocation(state);
    const categoryPath =
        getSelectedCategoryPath(state) ||
        (location.pathname.toLowerCase().startsWith("/content/") ? "" : location.pathname);
    return {
        inStockRealTime: state.pages.productList.productFilters.inStockRealTime,
        searchQuery: state.pages.productList.productFilters.query,
        data: getProductListDataView(state),
        categoryPath,
    };
};

const mapDispatchToProps = {
    addProductFilters,
    removeProductFilters,
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & OwnProps;

const ProductListInStockRealTime: FC<Props> = ({
    inStockRealTime,
    searchQuery,
    addProductFilters,
    removeProductFilters,
    data,
    categoryPath,
}) => {
    const isAuthenticated = useIsAuthenticated();
    const maxProducts = usePriceSortMaximum();
    const [isRendered, setIsRendered] = useState<boolean | null>(null);
    const [previousCatagoryPath, setPreviousCatagoryPath] = useState<string | null>(null);
    const [previousSearch, setPreviousSearch] = useState<string | null>(null);
    const [previousItemCount, setPreviousItemCount] = useState<number | null>(null);

    if (!isAuthenticated || !data.value || !data.pagination) {
        return null;
    }

    // Only change rendered state if category or search changes and we have results
    if (
        (previousCatagoryPath !== categoryPath || previousSearch !== (searchQuery ?? "")) &&
        previousItemCount !== data.pagination.totalItemCount
    ) {
        setPreviousCatagoryPath(categoryPath);
        setPreviousSearch(searchQuery ?? "");
        setIsRendered(data.pagination?.totalItemCount <= maxProducts);
    }

    // Track last api call ending because we only care if category changes and need to wait for product results
    if (previousItemCount !== data.pagination.totalItemCount) {
        setPreviousItemCount(data.pagination?.totalItemCount);
    }

    // Handle first render
    if (isRendered === null) {
        setIsRendered(data.pagination?.totalItemCount <= maxProducts);
    }

    const onChangeFacet = (facet: FacetModel) => {
        if (facet.selected) {
            removeProductFilters({ inStockRealTime: false });
        } else {
            addProductFilters({ inStockRealTime: true, page: 1 });
        }
    };

    const facet = [
        {
            id: "stockedRealTime",
            name: translate("In Stock Items Only"),
            count: -1,
            selected: inStockRealTime ?? false,
        },
    ];

    return (
        <>
            {isRendered && (
                <ProductListFiltersAccordionSection
                    title={translate("Availability")}
                    facets={facet}
                    onChangeFacet={onChangeFacet}
                    showMoreLimit={1}
                    extendedStyles={productListCategoryFiltersStyles}
                    expandByDefault={true}
                />
            )}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ProductListInStockRealTime),
    definition: {
        group: "Product List",
        displayName: "In Stock Real Time Filter",
        allowedContexts: ["ProductListPage"],
    },
};

export default widgetModule;
